import { __decorate, __metadata } from "tslib";
import { makeObservable, observable } from "mobx";
var ContextMenuState = /** @class */ (function () {
    function ContextMenuState() {
        this.show = false;
        this.items = [];
        this.position = null;
        makeObservable(this);
    }
    __decorate([
        observable.ref,
        __metadata("design:type", Boolean)
    ], ContextMenuState.prototype, "show", void 0);
    __decorate([
        observable.ref,
        __metadata("design:type", Array)
    ], ContextMenuState.prototype, "items", void 0);
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], ContextMenuState.prototype, "position", void 0);
    return ContextMenuState;
}());
export { ContextMenuState };
